export default __webpack_public_path__ + "static/media/cashback-image-m.76dc01d6.svg";